import * as _ from 'lodash';
import createSelector from 'selectorator';

const getProjects = createSelector(['projects.projects']);
const getProjectList = createSelector([getProjects], _.values);

const REFERENCE_TYPE_BRANCH = 'branch';

// ProjectsPage query param selectors
const getLocator = (_state, props) => props.locator || props.projectId;
const getBranch = (_state, props) => props.branch;

const getSortMode = state => state.projects.sortMode;

const isReferenceTypeBranch = reference => reference.type === REFERENCE_TYPE_BRANCH;

const getProjectByLocator = createSelector(
  [getProjectList, getLocator],
  (projects, locator) => projects ? projects.find(project => project.locator === locator) : null,
);

const getProjectReferences = createSelector(
  [getProjectByLocator],
  (project) => project ? project.references : [],
);

const getBranchesForProject = createSelector(
  [getProjectReferences],
  (references) => references ? references.filter(isReferenceTypeBranch) : [],
);

const getProjectIsFetchingBranches = createSelector(
  [getProjectByLocator],
  (project) => project ? project.isFetchingBranches : false,
);

const getRevisionsForProject = createSelector(
  [getProjectByLocator, getBranch],
  (project, selectedBranch) => {
    const revisions = project ? project.revisions : {};
    return revisions?.[selectedBranch] ?? [];
  },
);

const getProjectIsFetchingRevisions = createSelector(
  [getProjectByLocator],
  (project) => project ? project.isFetchingRevisions : false,
);

export default {
  getStatus: createSelector(['projects.status']),
  getProjects,
  getProjectList,
  getSortMode,
  getBranchesForProject,
  getProjectIsFetchingBranches,
  getRevisionsForProject,
  getProjectIsFetchingRevisions,
};
